import React, { useMemo } from "react";
import YouTube from 'react-youtube';

export default function YouTubePlayer({
    videoId,
    onReady,
    onPlay,
    onPause,
    onEnd,
    onStateChange,
}) {
    const opts = useMemo(() => ({
        playerVars: {
            autoplay: 1,
            color: 'white',
            controls: 1,
            fs: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            rel: 0,
            showinfo: 0,
        }
    }), []);

    return (
        <div className={"youtube-wrapper"}>
            <div className={"youtube-container"}>
                <YouTube
                    className="video"
                    height="100%"
                    style={{ height: "100%", width: "100%" }}
                    key={videoId}
                    videoId={videoId}
                    opts={opts}
                    onReady={onReady}
                    onPlay={onPlay}
                    onPause={onPause}
                    onEnd={onEnd}
                    onStateChange={onStateChange}
                />
            </div>
        </div>
    );
}


